import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";

//Import Scrollbar
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isMobile } from "../../utils/browser";

import classname from "classnames";
import { isEmpty } from "lodash-es";

// 레프트메뉴 및 페이지 해더 좌우 스크롤 생길때 이질감 없도록 좌우 스크롤 움직임
const scrollEvnet = (_left) => {
  // const left = e.srcElement.scrollingElement.scrollLeft * -1;
  const left = _left * -1;
  if (
    !isEmpty(document.getElementsByClassName("vertical-menu")) &&
    !isEmpty(document.getElementsByClassName("page-header"))
  ) {
    document.getElementsByClassName("vertical-menu")[0].style[
      "margin-left"
    ] = `${left}px`;
    document.getElementsByClassName("page-header")[0].style[
      "margin-left"
    ] = `${left}px`;
  }
};

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: isMobile(),
      isTop: true,
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }

    // Scroll Top to 0
    window.scrollTo(0, 0);
    this.setState({ ...this.state, isTop: true })
    // let currentage = this.capitalizeFirstLetter(this.props.location.pathname);

    // document.title = currentage + " | " + process.env.REACT_APP_APPFULLNAME;
    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme);
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
  }
  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === "default") {
      this.props.changeSidebarType("condensed", this.state.isMobile);
    } else if (this.props.leftSideBarType === "condensed") {
      this.props.changeSidebarType("default", this.state.isMobile);
    }
  };

  render() {
    return (
      <React.Fragment>
        <PerfectScrollbar
          onScrollX={container => scrollEvnet(container.scrollLeft)}
        >
          <div id="preloader">
            <div id="status">
              <div className="spinner-chase">
                <div className="chase-dot"></div>
                <div className="chase-dot"></div>
                <div className="chase-dot"></div>
                <div className="chase-dot"></div>
                <div className="chase-dot"></div>
                <div className="chase-dot"></div>
              </div>
            </div>
          </div>

          <div id="layout-wrapper" className={classname({
            "is-none-top": !this.state.isTop
          })}>
            <Sidebar
              toggleMenuCallback={this.toggleMenuCallback}
              theme={this.props.leftSideBarTheme}
              type={this.props.leftSideBarType}
              isMobile={this.state.isMobile}
            />
            <div className="main-container">
              <Header toggleMenuCallback={this.toggleMenuCallback} />
              <PerfectScrollbar
                className="body-scroll-y"
                onScrollY={container => this.setState({
                  ...this.state,
                  isTop: container.scrollTop === 0
                })}
              >
                <div className="main-content">
                  {this.props.children}
                </div>
              </PerfectScrollbar>
            </div>
            {/* <Footer /> */}
          </div>
        </PerfectScrollbar>
      </React.Fragment >
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout));
